<div *ngIf="formattedCustomFieldQuestions$ | async as questions" class="gb-event-ticket-questions-form">
  <div class="question-container">
    <gb-dynamic-form-question
      *ngFor="let question of questions | gbOrderBy: 'order'"
      [question]="question"
      [form]="questionsForm"
    >
    </gb-dynamic-form-question>
  </div>
</div>
